// extracted by mini-css-extract-plugin
export default {"popup":"Style_popup__gTk6G","content":"Style_content__pI3ns","Title":"Style_Title__OZXA1","btnBox":"Style_btnBox__o5Mlk"};